import React, { useEffect, useState } from "react";
import { List } from "antd";
import Api from "../../../../services/ServiceApi";
import { InsuranceFilled } from "@ant-design/icons";
import moment from "moment";
const BusDetailPanel = ({ busDetailData }) => {
  function isNull(data) {
    return data === null ? "-" : data;
  }
  function checkAreaAndAdType(hasArea, title) {
    // if (hasArea === 1) {
    //   return (
    //     <List.Item>
    //       <span className="d-flex align-items-center">
    //         <img src={Api.absoluteUrl("/img/icon_active_checkbox.svg")}   width="50px" classNam="mr-2"/>
    //         {title}
    //       </span>
    //     </List.Item>
    //   );
    // } else {
      return (
        <List.Item>
          <span className="d-flex align-items-center">
          <img src={Api.absoluteUrl("/img/icon_nonactive_checkbox.svg")}   width="50px" classNam="mr-2"/>
            {title}
          </span>
        </List.Item>
      );
    // }
  }
  const externalAreaData = [
    {
      id: "1",
      title: "External - FW",
    },
    {
      id: "2",

      title: "External - HW",
    },
    {
      id: "3",

      title: "External - QW",
    },
    {
      id: "4",

      title: "External - Special",
    },
  ];
  const internalAreaData = [
    {
      id: "1",

      title: "Internal - In Bus",
    },
    {
      id: "2",

      title: "Internal - Hanger",
    },
    {
      id: "3",

      title: "Internal - LCD",
    },
  ];
  const advertisingTypeData = [
    {
      id: "1",

      title: "2D",
    },
    {
      id: "2",

      title: "3D",
    },
    {
      id: "3",

      title: "Lightning",
    },
    {
      id: "4",

      title: "Reflective Film",
    },
  ];
  const gray_dot = {
    height: "12px",
    width: "12px",
    "background-color": "#e3e3e3",
    "border-radius": "50%",
    display: "inline-block",
    margin: "2px",
  };
  return (
    <div style={{ padding: "0 70px" }}>
      <div className="row">
        <div className="col-6">
          <div className="row">
            <div className="col-6">
              <span className="font-thai-b fs-22 c-blue">{"Area"}</span>
            </div>
            <div className="col-6">
              <span className="font-thai-b fs-22 c-gray">
                {" "}
                {busDetailData.area_id}{" "}
              </span>
            </div>
            <div className="col-6">
              <span className="font-thai-b fs-22 c-blue">{"Division"}</span>
            </div>
            <div className="col-6">
              <span className="font-thai-b fs-22 c-gray">
                {isNull(busDetailData.division_name)}
              </span>
            </div>
            <div className="col-6">
              <span className="font-thai-b fs-22 c-blue">{"Garage"}</span>
            </div>
            <div className="col-6">
              <span className="font-thai-b fs-22 c-gray">
                {" "}
                {isNull(busDetailData.garage_name)}{" "}
              </span>
            </div>
            <div className="col-6">
              <span className="font-thai-b fs-22 c-blue">{"Model"}</span>
            </div>
            <div className="col-6">
              <span className="font-thai-b fs-22 c-gray">
                {" "}
                {isNull(busDetailData.model_name)}{" "}
              </span>
            </div>
            <div className="col-6">
              <span className="font-thai-b fs-22 c-blue">{"Bus Group"}</span>
            </div>
            <div className="col-6">
              <span className="font-thai-b fs-22 c-gray">
                {" "}
                {isNull(busDetailData.bus_group_name)}{" "}
              </span>
            </div>
            <div className="col-6">
              <span className="font-thai-b fs-22 c-blue">{"Bus Type"}</span>
            </div>
            <div className="col-6">
              <span className="font-thai-b fs-22 c-gray">
                {" "}
                {isNull(busDetailData.bus_type_name)}{" "}
              </span>
            </div>
          </div>
        </div>
        <div className="col-6">
          <div className="row">
            <div className="col-6">
              <span className="font-thai-b fs-22 c-blue">{"Media ID"}</span>
            </div>
            <div className="col-6">
              <span className="font-thai-b fs-22 c-gray">
                {" "}
                {isNull(busDetailData.media_id)}{" "}
              </span>
            </div>
            <div className="col-6">
              <span className="font-thai-b fs-22 c-blue">{"Bus Contact"}</span>
            </div>
            <div className="col-6">
              <span className="font-thai-b fs-22 c-gray">
                {" "}
                {isNull(busDetailData.has_contract) === true
                  ? "Yes"
                  : "No"}{" "}
              </span>
            </div>
            <div className="col-6">
              <span className="font-thai-b fs-22 c-blue">
                {"Contract Expired"}
              </span>
            </div>
            <div className="col-6">
              <span className="font-thai-b fs-22 c-gray"> {moment(busDetailData.contact_expire_date).format("DD/MM/YYYY")} </span>
            </div>
            <div className="col-6">
              <span className="font-thai-b fs-22 c-blue">{"Remark :"}</span>
            </div>
            <div className="col-6">
              <span className="font-thai-b fs-22 c-gray">
                {" "}
                {isNull(busDetailData.remark)}
              </span>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div>
        <div>
          <div>
            {/* External Area List */}
            <span className="font-thai-b fs-22 c-blue">{"External Area"}</span>
            <br />
            <List
              grid={{ gutter: 16, column: 4 }}
              dataSource={externalAreaData}
              renderItem={(item) => {
                switch (parseInt(item.id)) {
                  case 1:
                    checkAreaAndAdType(busDetailData.fw, item.title);

                    return(
                      <span className="d-flex align-items-center">
                        {busDetailData.fw === 1 ? <img src={Api.absoluteUrl("/img/icon_active_checkbox.svg")}  /> 
                        :<img src={Api.absoluteUrl("/img/icon_nonactive_checkbox.svg")}  /> }
                    <span className="ml-2"> {item.title} </span>
                    </span>
                    )
                    break;
                  case 2:
                    return(
                      <span className="d-flex align-items-center">
                        {busDetailData.hw === 1 ? <img src={Api.absoluteUrl("/img/icon_active_checkbox.svg")}  /> 
                        :<img src={Api.absoluteUrl("/img/icon_nonactive_checkbox.svg")}  /> }
                    <span className="ml-2"> {item.title} </span>
                    </span>
                    )
               
                    break;
                  case 3:
                    return(
                      <span className="d-flex align-items-center">
                        {busDetailData.qw === 1 ? <img src={Api.absoluteUrl("/img/icon_active_checkbox.svg")}  /> 
                        :<img src={Api.absoluteUrl("/img/icon_nonactive_checkbox.svg")}  /> }
                    <span className="ml-2"> {item.title} </span>
                    </span>
                    )
                    break;
                  case 4:
                    return(
                      <span className="d-flex align-items-center">
                        {busDetailData.special === 1 ? <img src={Api.absoluteUrl("/img/icon_active_checkbox.svg")}  /> 
                        :<img src={Api.absoluteUrl("/img/icon_nonactive_checkbox.svg")}  /> }
                    <span className="ml-2"> {item.title} </span>
                    </span>
                    )
                    break;
                }
              }}
            />
          </div>
          <div>
            {/* Internal Area List*/}
            <span className="font-thai-b fs-22 c-blue">{"Internal Area"}</span>
            <br />
            <List
              grid={{ gutter: 16, column: 4 }}
              dataSource={internalAreaData}
              renderItem={(item) => {
                switch (parseInt(item.id)) {
                  case 1:
                    return(
                      <span className="d-flex align-items-center">
                        {busDetailData.ib === 1 ? <img src={Api.absoluteUrl("/img/icon_active_checkbox.svg")}  /> 
                        :<img src={Api.absoluteUrl("/img/icon_nonactive_checkbox.svg")}  /> }
                    <span className="ml-2"> {item.title} </span>
                    </span>
                    )
                    break;
                  case 2:
                    return(
                      <span className="d-flex align-items-center">
                        {busDetailData.hg === 1 ? <img src={Api.absoluteUrl("/img/icon_active_checkbox.svg")}  /> 
                        :<img src={Api.absoluteUrl("/img/icon_nonactive_checkbox.svg")}  /> }
                    <span className="ml-2"> {item.title} </span>
                    </span>
                    )
                    break;
                  case 3:
                    return(
                      <span className="d-flex align-items-center">
                        {busDetailData.lcd === 1 ? <img src={Api.absoluteUrl("/img/icon_active_checkbox.svg")}  /> 
                        :<img src={Api.absoluteUrl("/img/icon_nonactive_checkbox.svg")}  /> }
                    <span className="ml-2"> {item.title} </span>
                    </span>
                    )
                    break;
                }
              }}
            />
          </div>
          <div>
            {/* Advertising Type List */}
            <span className="font-thai-b fs-22 c-blue">
              {"Advertising Type"}
            </span>
            <br />
            <List
              grid={{ gutter: 16, column: 4 }}
              dataSource={advertisingTypeData}
              renderItem={(item) => {
                switch (parseInt(item.id)) {
                  case 1:
                    return(
                      <span className="d-flex align-items-center">
                        {busDetailData.two_d === 1 ? <img src={Api.absoluteUrl("/img/icon_active_checkbox.svg")}  /> 
                        :<img src={Api.absoluteUrl("/img/icon_nonactive_checkbox.svg")}  /> }
                    <span className="ml-2"> {item.title} </span>
                    </span>
                    )
                    break;
                  case 2:
                    return(
                      <span className="d-flex align-items-center">
                        {busDetailData.three_d === 1 ? <img src={Api.absoluteUrl("/img/icon_active_checkbox.svg")}  /> 
                        :<img src={Api.absoluteUrl("/img/icon_nonactive_checkbox.svg")}  /> }
                    <span className="ml-2"> {item.title} </span>
                    </span>
                    )
                    break;
                  case 3:
                    return(
                      <span className="d-flex align-items-center">
                        {busDetailData.led === 1 ? <img src={Api.absoluteUrl("/img/icon_active_checkbox.svg")}  /> 
                        :<img src={Api.absoluteUrl("/img/icon_nonactive_checkbox.svg")}  /> }
                    <span className="ml-2"> {item.title} </span>
                    </span>
                    )
                    break;
                  case 4:
                    return(
                      <span className="d-flex align-items-center">
                        {busDetailData.reflective_film === 1 ? <img src={Api.absoluteUrl("/img/icon_active_checkbox.svg")}  /> 
                        :<img src={Api.absoluteUrl("/img/icon_nonactive_checkbox.svg")}  /> }
                    <span className="ml-2"> {item.title} </span>
                    </span>
                    )

                    break;

                }
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusDetailPanel;
